import React, { Component } from 'react';
import moment from 'moment'

export default class StartCell extends Component {
  render() {
    return (
      <td className="start-cell md-up-only">{ moment(this.props.startTime).fromNow(true) }</td>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/StartCell.js
 **/